<template>
    <default-layout>
        <div class="main doc">
            <sidebar-menu :menu="menu" :showOneChild="true" :hideToggle="true" />
            <button class="btn btn-outline-secondary btn-sm hide-sidebar" @click="hideSidebar"><i class="fa fa-chevron-left"></i></button>
            <button class="btn btn-outline-secondary show-sidebar" @click="showSidebar">
                <i class="fa fa-chevron-right" style="position: relative; left: -4px"></i>
            </button>

            <div class="content">
                <nuxt />
            </div>
        </div>
    </default-layout>
</template>

<style>
.main {
    position: relative;
    width: 100%;
    min-height: calc(100vh - 56px);
}

.hide-sidebar {
    position: absolute;
    z-index: 6;
    left: 310px;
    top: 25px;
}

.button-line {
    width: 100%;
    height: 38px;
    margin-bottom: 20px;
}

.button-line .btn-left {
    float: left;
}

.button-line .btn-right {
    float: right;
}

.show-sidebar {
    position: fixed;
    left: 0;
    top: 0px;
    color: #fff;
    bottom: 0px;
    width: 10px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
    z-index: 0;
    border-radius: 0px;
    border-left: none;
    border-top: none;
    border-bottom: none;
    display: none;
}

.hide-sidebar,
.show-sidebar {
    color: #526488;
    border-color: #526488;
}

.v-sidebar-menu.vsm_expanded + .content {
    width: calc(100% - 350px);
    margin-left: 350px;
}

.v-sidebar-menu.vsm_collapsed + .content {
    width: calc(100% - 50px);
    margin-left: 50px;
}

.vsm--header {
    margin-top: 20px;
}

.content {
    padding-left: 350px;
}

.content h1 {
    font-size: 45px;
}

.content .button {
    border: 1px solid #3f3f3f;
    display: inline-block;
    padding: 0 4px;
    margin: 2px;
    border-radius: 4px !important;
}

img {
    max-width: 100%;
    padding-top: 5px;
    padding-bottom: 20px;
}

@media (max-device-width: 1024px) {
    .hide-sidebar {
        display: none;
    }

    .show-sidebar {
        display: block;
    }

    .v-sidebar-menu {
        display: none;
    }

    .content {
        padding-left: 20px;
    }
}

.v-sidebar-menu {
    background-color: #f5f5f5 !important;
}

.vsm--arrow {
    color: #212529;
}

.vsm--list {
    background-color: #f5f5f5 !important;
    color: #212529;
}

.vsm--link span {
    color: rgba(0, 0, 0, 0.5) !important;
}

.vsm--link_active {
    background-color: #f5f5f5 !important;
}

.vsm--link.vsm--link_active span {
    color: #526488 !important;
}

.v-sidebar-menu .vsm--header {
    color: #526488;
    font-size: 18px;
}

.v-sidebar-menu .vsm--link {
    padding: 6px;
    padding-left: 10px;
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    color: #35495e;
    background-color: rgba(0, 0, 0, 0.1) !important;
}

.v-sidebar-menu .vsm--link.vsm--link_level-2 {
    padding: 4px;
    padding-left: 15px;
}

.vsm--link:hover,
.vsm--link.vsm--link_hover span {
    background-color: transparent !important;
    color: #35495e !important;
}

.v-sidebar-menu {
    position: absolute !important;
    top: 0px;
    bottom: 0px;
    background-color: #3b4354;
    z-index: 4;
}

h1 {
    padding-top: 40px;
}
</style>

<script>
import DefaultLayout from "./DefaultLayout.vue";
import { SidebarMenu } from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

export default {
    components: {
        DefaultLayout,
        SidebarMenu
    },
    methods: {
        // actually not a toggle, just hide the sidebar menu
        hideSidebar() {
            $(".v-sidebar-menu").hide();
            $(".hide-sidebar").hide();
            $(".show-sidebar").show();
            $(".content").css("padding-left", "20px");
        },

        showSidebar() {
            $(".v-sidebar-menu").show();
            $(".hide-sidebar").show();
            $(".show-sidebar").hide();
            $(".content").css("padding-left", "350px");
        }
    },
    data() {
        return {
            menu: [
                {
                    header: true,
                    title: "Documentation Cardano",
                    hiddenOnCollapse: true
                },
                {
                    href: "/doc-cardano/qu-est-ce-que-cardano",
                    title: "La blockchain Cardano",
                    child: [
                        /*
                        {
                            href: "/doc-cardano/qu-est-ce-que-cardano#pourquoi-cardano",
                            title: "Pourquoi Cardano"
                        },
                        {
                            href: "/doc-cardano/qu-est-ce-que-cardano#developpement-de-cardano",
                            title: "Développement de Cardano"
                        },
                        {
                            href: "/doc-cardano/qu-est-ce-que-cardano#defis-de-cardano",
                            title: "Défis de Cardano"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-cardano#fonctionnalites-de-cardano",
                            title: "Fonctionnalités de Cardano"
                        }
                        */
                        {
                            href: "/doc-cardano/qu-est-ce-que-cardano",
                            title: "Pourquoi Cardano ?"
                        },
                        {
                            href: "/doc-cardano/le-developpement-de-cardano",
                            title: "Qui est derrière Cardano ?"
                        },
                        {
                            href: "/doc-cardano/les-phases-de-cardano-roadmap",
                            title: "Fonctionnalités et Roadmap de Cardano"
                        },
                        {
                            href: "/doc-cardano/les-defis-de-cardano",
                            title: "Les défis de Cardano"
                        }
                    ]
                },
                {
                    href:
                        "/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos",
                    title: "Le Delegated Proof of Stake (DPoS)",
                    /* icon: "fas fa-chart-area", */
                    child: [
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos#les-garanties-des-blockchain",
                            title: "Les garanties des blockchain"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos#le-proof-of-work",
                            title: "Le Proof of Work"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos#le-proof-of-stake",
                            title: "Le Proof of Stake"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos#le-delegated-proof-of-stake",
                            title: "Le Delegated Proof of Stake"
                        }
                    ]
                },
                {
                    href: "/doc-cardano/qu-est-ce-que-la-cryptomonnaie-ADA",
                    title: "ADA, la cryptomonnaie",
                    /* icon: "fas fa-chart-area", */
                    child: [
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-la-cryptomonnaie-ADA#distribution-de-ada",
                            title: "Distribution"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-la-cryptomonnaie-ADA#fonctionnalites-de-ada",
                            title: "Fonctionnalités"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-que-la-cryptomonnaie-ADA#progression-de-ada",
                            title: "Progression"
                        }
                    ]
                },
                {
                    href: "/doc-cardano/qu-est-ce-que-le-staking",
                    title: "Le Staking",
                    /* icon: "fas fa-chart-area", */
                    child: [
                        {
                            href: "/doc-cardano/qu-est-ce-que-le-staking",
                            title: "Qu'est-ce que le Staking ?"
                        },
                        {
                            href:
                                "/doc-cardano/les-portefeuilles-compatibles-avec-le-staking-d-ADA",
                            title: "Les portefeuilles compatibles"
                        }
                    ]
                },
                {
                    href: "/doc-cardano/qu-est-ce-qu-une-stake-pool",
                    title: "Les Stake Pools",
                    /* icon: "fas fa-chart-area", */
                    child: [
                        {
                            href:
                                "/doc-cardano/qu-est-ce-qu-une-stake-pool#stake-pool-definition",
                            title: "Définition"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-qu-une-stake-pool#stake-pool-fonctionnement",
                            title: "Fonctionnement"
                        },
                        {
                            href:
                                "/doc-cardano/qu-est-ce-qu-une-stake-pool#stake-pool-division-des-recompenses",
                            title: "Récompenses"
                        }
                    ]
                },
                {
                    header: true,
                    title: "Tutoriels",
                    hiddenOnCollapse: true
                },
                {
                    title: "ADAs Staking",
                    /* icon: "fas fa-chart-area", */
                    child: [
                        {
                            href:
                                "/tutoriel/comment-choisir-une-stake-pool-pour-deleguer-ses-ADAs",
                            title: "Choisir une Stake Pool"
                        },
                        {
                            href:
                                "/tutoriel/comment-staker-ses-ADAs-avec-Daedalus",
                            title: "Déléguer ses ADAs avec Daedalus (HOT)"
                        },
                        {
                            href:
                                "/tutoriel/comment-staker-ses-ADAs-avec-Yoroi",
                            title: "Déléguer ses ADAs avec Yoroi (COLD)"
                        },
                        {
                            href:
                                "/tutoriel/comment-staker-ses-ADAs-avec-Adalite",
                            title: "Déléguer ses ADAs avec Adalite (COLD)"
                        }
                    ]
                }
            ]
        };
    }
};
</script>